import { render } from "./Target.vue?vue&type=template&id=54dc1d66&ts=true"
import script from "./Target.vue?vue&type=script&lang=ts"
export * from "./Target.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__